<template>
  <div class="asap-box">
    <div class="filter-box">
      <div class="date-input">
        <datepicker :format="calendarFormat" v-model="start"
          :class="['datepicker inline', {'has-error':!!validation.start}]"
        ></datepicker>
        <span class="error-msg">{{validation.start}}</span>
      </div>
      <div class="date-input">
        <datepicker :format="calendarFormat"  v-model="end"
          :class="['datepicker inline', {'has-error':!!validation.end}]"
        ></datepicker>
        </div>
      <button @click="getServices" class="button cta small" >
        Submit
      </button>
    </div>

    <div class="card-box summary d-flex align-stretch">
      <div class="data d-flex flex-column justify-space-between">
        <label>Attempts</label>
        <b>{{ stats.attempts }}</b>
      </div>
      <div class="data d-flex flex-column justify-space-between">
        <label>Unique Consumer</label>
        <b>{{ stats.cons }}</b>
      </div>
      <div class="data d-flex flex-column justify-space-between">
        <label>Unique Reservation</label>
        <b>{{ stats.rsvpId }}</b>
      </div>
      <div class="data d-flex flex-column justify-space-between charged">
        <label>Completed</label>
        <b>{{ stats.success }}</b>
      </div>
      <!-- <div class="data d-flex flex-column justify-space-between no-show">
        <label>No Show</label>
        <b>{{ stats.noshow }}</b>
      </div> -->
      <div class="data d-flex flex-column justify-space-between canceled">
        <label>Canceled</label>
        <b>{{ stats.canceled }}</b>
      </div>
      <div class="data d-flex flex-column justify-space-between failed">
        <label>Failed</label>
        <b>{{ stats.failedAttempts }}</b>
      </div>
    </div>

    <table class="table-box" cellspacing="0">
      <thead>
        <th>Bid ID</th>
        <th>Created</th>
        <th>Consumer</th>
        <th>Device Type</th>
        <th>Brand</th>
        <th>Service Type</th>
        <!-- <th>Cons Token</th> -->
        <th>Pickup</th>
        <th>Dropoff</th>
        <th>Amount</th>
        <!-- <th>Stripe</th> -->
        <th>RSVP ID</th>
        <!-- <th>Last Sent to</th> -->
        <!-- <th>Assigned Prov</th> -->
        <th>Canceled</th>
        <th>Notes</th>
      </thead>
      <tbody>
        <tr v-if="list && !list.length">
          <td colspan="13" class="empty">No record found.</td>
        </tr>
        <tr v-for="dat in list" v-if="!dat.isGroupMember || showGroup.indexOf(dat.consId) > -1" :class="{isSub:dat.isGroupMember}">
          <td>{{ dat.custBid }}</td>
          <td class="date">{{ formatDate(dat.created) }}</td>
          <td class="cons-id">
            <div>
              <a :href="'/#/consumer/' + dat.consId" class="link" target="_blank" v-if="dat.consId">{{dat.consId}}</a>
              <i :class="['fas', showGroup.indexOf(dat.consId) == -1 ? 'fa-chevron-down' : 'fa-chevron-up']" v-show="dat.hasMultipleItems && !dat.isGroupMember" @click="toggleGroup(dat.consId)"></i>
            </div>
          </td>
          <td style="text-transform: capitalize;">{{ deviceLabel(dat.deviceType) }}</td>
          <td>{{ brandLabel(dat.brandId) }}</td>
          <td>{{ serviceTypeLabel(dat.serviceTypeId) }}</td>
          <!-- <td class="token">{{ dat.deviceID }}</td> -->
          <td>{{ dat.pickupTitle || '--' }}</td>
          <td>{{ dat.dropoffTitle || '--' }}</td>
          <td>
            <b v-if="dat.amount">${{ dat.amount }}</b>
            <span v-else>--</span>
          </td>
          <!-- <td>
            <a :href="stripLink(dat.stripeChargeId)" class="stripe link" target="_blank" v-if="dat.stripeChargeId" :title="dat.stripeChargeId"><i class="stripe-icon fab fa-stripe-s"></i></a>
          </td> -->
          <td>
            <a :href="'/#/reservation/' + dat.rsvpId" class="link" target="_blank" v-if="dat.rsvpId">{{dat.rsvpId}}</a>
            <span v-else>--</span>
          </td>
          <!-- <td>{{ dat.sendTo || '--' }}</td> -->
          <!-- <td>
            <a :href="'/#/provider/' + dat.acceptProv" class="link" target="_blank" v-if="dat.acceptProv">{{dat.acceptProv}}</a>
            <span v-else>--</span>
          </td> -->
          <td>
            <span v-if="dat.canceled" class="date cancel">{{ formatDate(dat.canceled, true) }}</span>
            <span v-else>--</span>
          </td>
          <td>
            <span v-if="dat.lyftError" class="date cancel">{{ dat.lyftError }}</span>
            <span v-else>--</span>
          </td>
        </tr>
        <tr v-show="list.length">
          <td colspan="8"></td>
          <td><b style="font-size:18px;">${{ total.amount.toFixed(2) }}</b></td>
          <td colspan="3"></td>
        </tr>
      </tbody>
    </table>

    <div class="cards">
      <div v-if="list && !list.length">
        <td colspan="10" class="empty">No record found.</td>
      </div>
      <div v-for="dat in list" :key="dat.custBid" :class="['card', {'in-group':dat.isGroupMember || dat.hasMultipleItems}]">
        <div class="title head-title">
          <div class="d-flex">
            <div class="label">Bid ID</div>
            <div class="value">{{ dat.custBid }}</div>
          </div>
          <div class="value">{{ formatDate(dat.created) }}</div>
        </div>
        <div class="title">
          <div class="label">Consumer</div>
          <div class="value">
            <a :href="'/#/consumer/' + dat.consId" class="link" target="_blank" v-if="dat.consId">{{dat.consId}}</a>
          </div>
        </div>
        <!-- <div class="title">
          <div class="label">Cons Token</div>
          <div class="value token">
            {{ dat.deviceID }}
          </div>
        </div> -->
        <div class="title">
          <div class="label">Pickup</div>
          <div class="value token">{{ dat.pickupTitle || '--' }}</div>
        </div>
        <div class="title">
          <div class="label">Dropoff</div>
          <div class="value token">{{ dat.dropoffTitle || '--' }}</div>
        </div>
        <div class="title">
          <div class="label">Amount</div>
          <div class="value">
            <b v-if="dat.amount">${{ dat.amount }}</b>
            <span v-else>--</span>
          </div>
        </div>
        <div class="title">
          <div class="label">Stripe</div>
          <div class="value">
            <a :href="stripLink(dat.stripeChargeId)" class="stripe link" target="_blank" v-if="dat.stripeChargeId">{{dat.stripeChargeId}}</a>
          </div>
        </div>
        <div class="title">
          <div class="label">RSVP ID</div>
          <div class="value">
            <a :href="'/#/reservation/' + dat.rsvpId" class="link" target="_blank" v-if="dat.rsvpId">{{dat.rsvpId}}</a>
            <span v-else>--</span>
          </div>
        </div>
        <div class="title">
          <div class="label">Last Sent to</div>
          <div class="value">{{ dat.sendTo || '--' }}</div>
        </div>
        <div class="title">
          <div class="label">Assigned Prov</div>
          <div class="value">{{ dat.acceptProv || '--' }}</div>
        </div>
        <div class="title">
          <div class="label">Canceled</div>
          <div class="value">
            <span v-if="dat.canceled" class="date cancel">{{ formatDate(dat.canceled, true) }}</span>
            <span v-else>--</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import ApiServices from '@/modules/api/services'

export default {
  name: 'asap',
  components: { datepicker },
  data () {
    return {
      triggerOnLoad: false,
      start: '',
      end: '',
      validation: {
        start: '',
        end: ''
      },
      list: [],
      showGroup: [],
      stats: {
        attempts: 0,
        cons: 0,
        rsvpId: 0,
        success: 0,
        canceled: 0,
        failedAttempts: 0
      },
      total: {
        amount: 0
      }
    }
  },
  computed: {
    services () { return this.$store.state.services.list }
  },
  methods: {
    checkLoaded () {
      if (!this.triggerOnLoad) {
        this.triggerOnLoad = true
        this.getServices()
        // this.getASAPList()
      }
    },
    calendarFormat (date) { return moment(date).format('MM/DD/YYYY') },
    getServices () {
      let self = this
      if (self.services.length) {
        self.getASAPList()
        return
      }

      self.$store.commit('global/setLoaderData', {show: true})
      ApiServices.getAllService(self, r => {
        self.getASAPList()
      })
    },
    getASAPList () {
      let self = this

      let start = moment(self.start, 'MM/DD/YYYY').set('hour', 0).set('minute', 0)
      let end = moment(self.end, 'MM/DD/YYYY').set('hour', 23).set('minute', 59)
      self.validation.start = ''
      if (end.diff(start, 'days') < 0) {
        self.validation.start = 'Cannot be greater than end date.'
        return
      }

      // Reset
      self.showGroup = []
      self.stats = {
        attempts: 0,
        cons: 0,
        rsvpId: 0,
        success: 0,
        canceled: 0,
        failedAttempts: 0
      }
      self.total = {
        amount: 0
      }

      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.get('/utils/listasap2', {
        start: start.format('YYYY-MM-DD'),
        end: end.format('YYYY-MM-DD')
      }, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
        }
        if (!r.list.length) {
          self.list = []
          return
        }

        const grouped = r.list.reduce((map, obj) => {
          const key = obj.consId
          if (!map.has(key)) map.set(key, [])
          map.get(key).push(obj)
          return map
        }, new Map())

        const result = Array.from(grouped.values()).flatMap(group => 
          group.sort((a, b) => b.custBid - a.custBid)
            .map((item, index) => ({
              ...item,
              isGroupMember: index > 0, // true for all except first item
              hasMultipleItems: group.length > 1
            }))
        )

        result.forEach(data => {
          if (data.isGroupMember) return
          self.stats.cons += 1
        })


        let tmpRsvp = []
        r.list.forEach(x => {
          if (x.rsvpId) tmpRsvp.push(x.rsvpId)
          if (x.rsvpId && !x.canceled) {
            self.stats.success += 1
            self.total.amount += parseFloat(x.amount.toFixed(2))
          }
          else if (x.canceled) self.stats.canceled += 1
          else if (!x.canceled && x.lyftError) self.stats.failedAttempts += 1
          else self.stats.failedAttempts += 1
        })

        self.stats.attempts = r.list.length
        self.stats.rsvpId = new Set(tmpRsvp).size
        self.list = result // USE THIS FOR GROUP CONSUMER
        // self.list = r.list // USE THIS TO UNGROUP CONSUMER
      }, '')
    },
    formatDate (x, convertToLA) {
      let format = 'MMM DD, YYYY hh:mmA'
      if (convertToLA) return moment.utc(x, 'YYYY-MM-DD@hh:mm:ss').tz('America/Los_Angeles').format(format)
      return moment(x, 'YYYY-MM-DD@hh:mm:ss', 'America/Los_Angeles').format(format)
    },
    stripLink (x) {
      let url = 'https://dashboard.stripe.com/payments/'
      if (CONFIG.Env !== 'production') url = 'https://dashboard.stripe.com/test/payments/'
      return `${url}${x}`
    },
    toggleGroup (x) {
      if (this.showGroup.indexOf(x) == -1) this.showGroup.push(x)
      else this.showGroup.splice(this.showGroup.indexOf(x), 1)
    },
    deviceLabel (x) {
      if (!x) return '--'
      if (x === 'ww') return 'Web'
      return x
    },
    brandLabel (id) {
      let brand = CONFIG.brands.find(x => x.id === id)
      if (brand) return brand.name
      return id
    },
    serviceTypeLabel (id) {
      let stagingLyft = [280, 281, 281, 281, 281]
      let prodLyft = [201, 208, 215, 218, 216, 207, 203, 212, 206, 210, 217, 209, 205, 213, 211, 202, 204, 214]
      let lyftIDs = CONFIG.Env === "production" ? prodLyft : stagingLyft
      if (lyftIDs.indexOf(id) > -1) return 'Lyft'

      let service = this.services.find(x => x.id === id)
      if (service) return service.label

      return id
    }
  },
  mounted () {
    // this.start = moment().subtract(7, 'days').format('MM/DD/YYYY')
    this.start = moment().format('MM/DD/YYYY')
    this.end = moment().format('MM/DD/YYYY')
  }
}
</script>

<style lang="scss" scoped>
.asap-box{
  padding: 15px;
}

.filter-box{
  display: flex;
  width: 100%;
  border: 1px solid #ccc;
  background: #fafafa;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 15px;
  align-items: start!important;
  
  .error-msg{
    font-size: 13px;
    color: #f00;
  }
  .button{
    line-height: 20px;
    padding: 10px 20px;
  }
}
.datepicker{
  margin-right: 10px;
}

.card-box{
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 4px;
  gap: 10px;
  padding: 10px;
  width: fit-content;
  margin-bottom: 10px;

  .data{
    padding: 10px;
    background: #fafafa;
    border: 1px solid #eee;
    border-radius: 2px;
    width: 120px;

    &.grayed{
      background: #f2f2f2;
    }
    label{
      display: block;
      line-height: 1;
      letter-spacing: .5px;
      margin-bottom: 10px;
      color: #777;
      font-size: 15px;
      font-weight: 600;
    }
    b{
      font-size: 32px;
      line-height: 1;
    }
    &.charged{
      background: #e0ffd6;
      color: #338509;
      border-color: #338509;
      label{
        color: #338509;
      }
    }
    &.no-show{
      background: #ffe9c1;
      color: #d37f02;
      border-color: #d37f02;
      label{
        color: #d37f02;
      }
    }
    &.canceled{
      background: #ffd1d1;
      color: #b30202;
      border-color: #b30202;
      label{
        color: #b30202;
      }
    }
    &.failed{
      background: #b3b3b3;
      border-color: #333;
      label{
        color: #333;
      }
    }
  }
}

.table-box{
  margin-top: 30px;
  width: 100%;
  border: 1px solid #333;
  background: #fafafa;
  border-radius: 4px;
  overflow: hidden;

  th{
    border-bottom: 1px solid #ddd;
    padding: 5px;
    background: #333;
    color: #fff;
  }
  tr{
    text-align: center;
  }
  td{
    font-size: 14px;
    padding: 7px;
  }
  tr:nth-child(odd) td{
    background: #f3f3f3;
  }
  .empty{
    padding: 30px;
    font-weight: 600;
    font-size: 28px;
    color: #777;
  }
}
.isSub{
  td {
    font-size: 12px;
    background: #e8f6ff!important;
  }
}
.date{
  color: #777;

  &.cancel{
    color: #f00;
  }
}
.cons-id{
  padding-right:27px;
  
  div{
    position: relative;
    display: inline-block;
  }
  i{
    position: absolute;
    top: 4px;
    right: -20px;
    cursor: pointer;
  }
}
.token{
  font-size: 13px;
  color: #777;
}

.cards {
  display: none;
}

@media only screen and (max-width: 430px){
  .filter-box {
    display: flex;
    flex-wrap: wrap;

    .date-input {
      width: 50%;

      
      &:nth-of-type(2) {
        .datepicker {
          margin: 0;
        }
        /deep/ .vdp-datepicker__calendar {
          right: 0;
        }
      }

    }

    .button {
      width: 100%;
      margin-top: 10px;
    }
  }

  .table-box {
    display: none;
  }

  .cards {
    display: block;
    padding-top: 10px;
    padding-bottom: 100px;

    .card {
      border: 1px solid #ccc;
      margin: 15px 0;
      padding: 8px;
      padding-bottom: 3px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;
      font-weight: 700;

      &.in-group{
        margin: 0;
        border-bottom: 2px solid #aaa9;
        border-radius: 0;
      }

      > div {
        margin-bottom: 3px;
      }

      .title {
        display: flex;
        align-items: center;
        &.head-title {
          justify-content: space-between;
          align-items: start;

          .value {
            margin: 0;
            font-weight: 400;
          }
        }
      }

      .label {
        font-size: 12px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
        margin-right: 5px;
      }

      .value {
        margin-right: 10px;
        font-size: 13px;
        font-weight: 900;

        i {
          opacity: 0.3;
        }

        &.token {
          font-size: 10px;
        }
      }

      .edit {
        text-align: right;
        margin-bottom: 10px;
        text-transform: uppercase;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AdminCode/asap.vue